import clsx from 'clsx'
import { asCurrency } from 'lib/utilities/number'
import Icon from '../Icon/Icon'
import { PromoCode } from '../PaymentDetails/partials/PromoCodeInput'

interface PromoCodeChipProps extends Omit<PromoCode, 'id'> {
  /**
   * The promo code
   */
  promoCode: string
  /**
   * The amount of discount in cents
   */
  discountCents?: number
  /**
   * Callback on promo code removal
   */
  onRemove?: () => void
  /**
   * Currency to display
   */
  currency?: Currency
}

const PromoCodeChip = ({
  promoCode,
  discountCents,
  onRemove,
  currency,
}: PromoCodeChipProps) => {
  return (
    <div
      className={clsx(
        'inline-flex items-center p-2 bg-neutral-200 rounded-8 justify-end',
        onRemove && 'cursor-pointer hover:bg-neutral-300',
      )}
      onClick={onRemove}
    >
      {onRemove && <Icon icon="close" className="block w-4 h-4 mr-2" />}
      <div className="text-[12px] uppercase">
        {discountCents
          ? `${promoCode} (-${asCurrency(discountCents / 100, currency)})`
          : promoCode}
      </div>
    </div>
  )
}

export default PromoCodeChip
